export interface IFileEntry {
  name: string
  type: 'image' | 'video' | 'pdf' | 'other'
  contentType: string
  customerId: string
  uuid: string
  uploadedAt: string
  updatedAt: string
  isCompressed: boolean
  /**
   * Which bucket the file is stored in.
   * If undefined, assume ATLASCLOUD_FILES
   */
  bucketName?: BucketName
  widths: {
    width: number
    uuid: string
  }[]
}

export interface FileEntryBM extends IFileEntry {}

export interface FileEntryFM extends FileEntryBM {
  size: number
  usedIn?: string
}

export enum BucketName {
  ATLASCLOUD_FILES = 'ATLASCLOUD_FILES', // 'atlascloud-files'
  ATLASCLOUD_ECOM_ASSETS = 'ATLASCLOUD_ECOM_ASSETS', // 'atlascloud-ecom-assets'
}
